import React from 'react';
import classNames from "classnames";

function Button({children, onClick, className, ...attrs}) {
    const classes = classNames(
        'button',
        className,
    )

    return (
        <button
            {...attrs}
            className={classes}
            onClick={onClick}
        >
            {children}
        </button>
    );
}

export default Button;